import { PageHeader } from "@/components/ui/page-header";
import { LoadingState } from "@/components/ui/loading-state";
import { usePackages } from "./hooks/usePackages";
import { PackageCard } from "./components/PackageCard";

const PackagesPage = () => {
  const { data: packages, isLoading, error, refetch } = usePackages();

  return (
    <div className="space-y-6">
      <PageHeader
        title="Packages"
        description="Presets for new and upgraded organizations. Applying one copies these values onto the organization, where each can still be changed; editing a package here does not change organizations already on it."
      />
      {isLoading || error || !packages ? (
        <LoadingState
          isLoading={isLoading}
          error={error}
          loadingText="Loading packages..."
          errorTitle="Failed to load packages"
          onRetry={() => refetch()}
        />
      ) : (
        <div className="grid gap-6 lg:grid-cols-2">
          {packages.map((pkg) => (
            <PackageCard key={pkg.key} pkg={pkg} />
          ))}
        </div>
      )}
    </div>
  );
};

export default PackagesPage;
